export default __webpack_public_path__ + "static/media/Skolen_i_skoven.242519c9.png";